import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { showErrorToast } from "#app/notifications";
import { clientQuery } from "#modules/clients/infra/client.query";

export const useClient = (id: string | undefined) => {
  const { data, error, ...rest } = useQuery({
    ...clientQuery(id),
  });

  useEffect(() => {
    if (error) {
      showErrorToast({ title: "Le client n'existe pas" });
    }
  }, [error]);

  return { client: data, ...rest };
};
